import { type FC } from "react";
import { faUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons";
import styles from "./viewContentLinkButton.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import { type RootState } from "features/Application/globaltypes/redux";
import { connect, type ConnectedProps } from "react-redux";

export interface ViewContentLinkButtonProps {
  href: string;
  text?: string;
  disabled?: boolean;
  additionalRootClassname?: string;
  fitted?: boolean;
}

// If not present, the links are prevented from navigating on left click
// by (I believe) a parent component
const clickHandler = (e: React.MouseEvent<HTMLAnchorElement>) => e.stopPropagation();

const ViewContentLinkButton: FC<ViewContentLinkButtonProps & PropsFromRedux> = ({
  additionalRootClassname,
  fitted,
  href,
  disabled,
  text = "View",
  isMobo,
}) => {
  if (isMobo) return null;

  return (
    <a
      onClick={clickHandler}
      className={cn(styles.viewContentLink, additionalRootClassname, {
        [styles.fitted]: fitted,
      })}
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
    >
      <div className={cn(styles.iconContainer, { [styles.smallerIcon]: fitted })}>
        <FontAwesomeIcon className={styles.icon} icon={faUpRightFromSquare} />
      </div>
      {text}
    </a>
  );
};

const mapStateToProps = (state: RootState) => ({
  isMobo: state.userProfile.isMobo,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(ViewContentLinkButton);

export default ConnectedComponent;
